var TMViz =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp_name_"];
/******/ 	window["webpackJsonp_name_"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"1":"main","2":"bordas"}[chunkId]||chunkId) + ".bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(12);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = _;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = d3;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	// misc. utilities
	
	//////////////////////////////////
	// Utilities for null/undefined //
	//////////////////////////////////
	
	// Assert non-null.
	// Return the value if it is not null or undefined; otherwise, throw an error.
	function nonNull(value) {
	  if (value == null) {
	    throw new Error('expected a non-null defined value, but got: ' + String(value));
	  }
	  return value;
	}
	
	// Null coalescing: iff the first argument is null or undefined, return the second.
	function coalesce(a, b) {
	  return (a != null) ? a : b;
	}
	
	// Apply a function to a value if non-null, otherwise return the value.
	// (Monadic bind for maybe (option) type.)
	// ((a -> b), ?a) -> ?b
	function applyMaybe(f, x) {
	  return (x != null) ? f(x) : x;
	}
	
	// Returns the first function result that is not null or undefined.
	// Otherwise, returns undefined.
	// ((a -> ?b), [a]) -> ?b
	function getFirst(f, xs) {
	  for (var i = 0; i < xs.length; ++i) {
	    var val = f(xs[i]);
	    if (val != null) {
	      return val;
	    }
	  }
	}
	
	/////////
	// DOM //
	/////////
	
	/* global document */
	
	/**
	 * Concat an array of DOM Nodes into a DocumentFragment.
	 * @param  {[Node]} array
	 * @return {DocumentFragment}
	 */
	function toDocFragment(array) {
	  var result = document.createDocumentFragment();
	  array.forEach(result.appendChild.bind(result));
	  return result;
	}
	
	///////////////////////
	// IE/Edge detection //
	///////////////////////
	
	// http://stackoverflow.com/a/9851769
	var isBrowserIEorEdge = /*@cc_on!@*/false
	  || Boolean(document.documentMode) || Boolean(window.StyleMedia); // eslint-disable-line
	
	
	exports.nonNull = nonNull;
	exports.coalesce = coalesce;
	exports.applyMaybe = applyMaybe;
	exports.getFirst = getFirst;
	
	exports.toDocFragment = toDocFragment;
	
	exports.isBrowserIEorEdge = isBrowserIEorEdge;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var jsyaml = __webpack_require__(19),
	    _ = __webpack_require__(1);
	
	// Document Serialization
	
	var docToYaml = {
	  name: 'name',
	  sourceCode: 'source code',
	  positionTable: 'positions',
	  editorSourceCode: 'editor contents'
	};
	var yamlToDoc = _.invert(docToYaml);
	
	// like _.mapKeys, but only using the keys specified in a mapping object.
	// {[key: string] -> string} -> ?Object -> Object
	function mapKeys(mapping) {
	  return function (input) {
	    var output = {};
	    if (input != null) {
	      Object.keys(mapping).forEach(function (fromKey) {
	        var toKey = mapping[fromKey];
	        output[toKey] = input[fromKey];
	      });
	    }
	    return output;
	  };
	}
	
	// we want parseDocument . stringifyDocument = identity, up to null == undefined.
	
	/**
	 * Serialize a document.
	 * For each state node position, only .x, .y, and .fixed are saved.
	 * .fixed is omitted if true (its default value).
	 * @param  {TMDocument} doc document to serialize
	 * @return {string}
	 */
	var stringifyDocument = _.flow(
	  mapKeys(docToYaml),
	  _.omitBy(function (x) { return x == null; }),
	  _.update('positions', _.mapValues(function (pos) {
	    return pos.fixed
	      ? {x: pos.x, y: pos.y}
	      : {x: pos.x, y: pos.y, fixed: false};
	  })),
	  // NB. lodash/fp/partialRight takes an array of arguments.
	  _.partialRight(jsyaml.safeDump, [{
	    flowLevel: 2,       // positions: one state per line
	    lineWidth: -1,      // don't wrap lines
	    noRefs: true,       // no aliases/references are used
	    noCompatMode: true  // use y: instead of 'y':
	  }])
	);
	
	/**
	 * Deserialize a document.
	 * State positions' .px and .py are optional and default to .x and .y.
	 * .fixed defaults to true.
	 * @param  {string} str    serialized document
	 * @return {Object}        data usable in TMDocument.copyFrom()
	 * @throws {YAMLException} on YAML syntax error
	 * @throws {TypeError}     when missing "source code" string property
	 */
	var parseDocument = _.flow(
	  jsyaml.safeLoad,
	  _.update('positions', _.mapValues(function (pos) {
	    // NB. lodash/fp/defaults is swapped: 2nd takes precedence
	    return _.defaults({px: pos.x, py: pos.y, fixed: true}, pos);
	  })),
	  mapKeys(yamlToDoc),
	  checkData
	);
	
	// throw if "source code" attribute is missing or not a string
	function checkData(obj) {
	  if (obj == null || obj.sourceCode == null) {
	    throw new InvalidDocumentError('The “source code:” value is missing');
	  } else if (!_.isString(obj.sourceCode)) {
	    throw new InvalidDocumentError('The “source code:” value needs to be of type string');
	  }
	  return obj;
	}
	
	// for valid YAML that is not valid as a document
	function InvalidDocumentError(message) {
	  this.name = 'InvalidDocumentError';
	  this.message = message || 'Invalid document';
	  this.stack = (new Error()).stack;
	}
	InvalidDocumentError.prototype = Object.create(Error.prototype);
	InvalidDocumentError.prototype.constructor = InvalidDocumentError;
	
	exports.stringifyDocument = stringifyDocument;
	exports.parseDocument = parseDocument;
	exports.InvalidDocumentError = InvalidDocumentError;
	
	// Re-exports
	exports.YAMLException = jsyaml.YAMLException;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = lodash;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var parseDocument = __webpack_require__(5).parseDocument;
	var fromPairs = __webpack_require__(1).fromPairs;
	
	
	function requireExample(name) {
	  return __webpack_require__(44)("./" + name + '.yaml');
	}
	
	var examplePairs = [
	  'repeat01',
	  'binaryIncrement',
	  'divisibleBy3',
	  'copy1s',
	  'divisibleBy3Base10',
	  'matchThreeLengths',
	  'matchBinaryStrings',
	  'palindrome',
	  'busyBeaver3',
	  'busyBeaver4',
	  'powersOfTwo',
	  'lengthMult',
	  'binaryAdd',
	  'unaryMult',
	  'binaryMult'
	].map(function (id) {
	  // parse each string into a document
	  var doc = parseDocument(requireExample(id));
	  doc.id = id;
	
	  return [id, doc];
	});
	var examples = Object.freeze(fromPairs(examplePairs));
	
	
	function isExampleID(docID) {
	  return {}.hasOwnProperty.call(examples, docID);
	}
	
	function get(docID) {
	  return isExampleID(docID) ? examples[docID] : null;
	}
	
	var list = examplePairs.map(function (pair) { return pair[1]; });
	
	
	exports.hasID = isExampleID;
	exports.get = get;
	exports.list = list;
	exports.firsttimeDocID = 'binaryIncrement';
	exports.blankTemplate = requireExample('_template');


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var parseSpec = __webpack_require__(14).parseSpec,
	    TMViz = __webpack_require__(12),
	    watchInit = __webpack_require__(17).watchInit,
	    values = __webpack_require__(6).values;
	
	/**
	 * Turing machine simulator component.
	 *
	 * Contains a state diagram, tape diagram, and button controls.
	 * @param {[type]} container [description]
	 * @param {[type]} buttons   [description]
	 */
	function TMSimulator(container, buttons) {
	  this.container = container;
	  this.buttons = buttons;
	
	  var self = this;
	  buttons.step
	      .addEventListener('click', function () {
	        self.machine.isRunning = false;
	        self.machine.step(); // each step click corresponds to 1 machine step
	      });
	  buttons.run
	      .addEventListener('click', function () {
	        self.machine.isRunning = !self.machine.isRunning;
	      });
	  buttons.reset
	      .addEventListener('click', function () {
	        self.machine.reset();
	      });
	  buttons.all = values(buttons);
	
	  this.clear();
	}
	
	TMSimulator.prototype.clear = function () {
	  this.sourceCode = null;
	};
	
	Object.defineProperties(TMSimulator.prototype, {
	  /**
	   * The machine's source code.
	   * • Setting a new source code will attempt to persist the state node positions.
	   * • To set a new machine, first call .clear(), then set the source code.
	   */
	  sourceCode: {
	    get: function () {
	      return this.__sourceCode;
	    },
	    // throws if sourceCode has errors
	    set: function (sourceCode) {
	      if (this.machine) {
	        this.machine.isRunning = false; // important
	        this.machine.stateviz.force.stop();
	      }
	      if (sourceCode == null) {
	        // clear display
	        this.machine = null;
	        this.container.innerHTML = '';
	      } else {
	        // parse & check, then set
	        var spec = parseSpec(sourceCode);
	        if (this.machine) {
	          // case: update
	          // copy & restore positions, clear & load contents
	          var posTable = this.machine.positionTable;
	          this.clear();
	          this.machine = new TMViz(this.container, spec, posTable);
	        } else {
	          // case: load new
	          this.machine = new TMViz(this.container, spec);
	        }
	      }
	      this.__sourceCode = sourceCode;
	    },
	    enumerable: true
	  },
	  positionTable: {
	    get: function () {
	      return this.machine && this.machine.positionTable;
	    },
	    set: function (posTable) {
	      if (this.machine && posTable) {
	        this.machine.positionTable = posTable;
	      }
	    },
	    enumerable: true
	  },
	  machine: {
	    get: function () {
	      return this.__machine;
	    },
	    set: function (machine) {
	      this.__machine = machine;
	      this.rebindButtons();
	    }
	  }
	});
	
	/////////////
	// Buttons //
	/////////////
	
	/**
	 * The innerHTML for the "Run" button.
	 * The default value can be overridden.
	 * @type {string}
	 */
	TMSimulator.prototype.htmlForRunButton =
	  '<span class="glyphicon glyphicon-play" aria-hidden="true"></span><br>Démarrer';
	TMSimulator.prototype.htmlForPauseButton =
	  '<span class="glyphicon glyphicon-play" aria-hidden="true"></span><br>Stopper';
	
	// bind: .disabled for Step and Run, and .innerHTML (Run/Pause) for Run
	function rebindStepRun(stepButton, runButton, runHTML, pauseHTML, machine) {
	  function onHaltedChange(isHalted) {
	    stepButton.disabled = isHalted;
	    runButton.disabled = isHalted;
	  }
	  function onRunningChange(isRunning) {
	    runButton.innerHTML = isRunning ? pauseHTML : runHTML;
	  }
	  watchInit(machine, 'isHalted', function (prop, oldval, isHalted) {
	    onHaltedChange(isHalted);
	    return isHalted;
	  });
	  watchInit(machine, 'isRunning', function (prop, oldval, isRunning) {
	    onRunningChange(isRunning);
	    return isRunning;
	  });
	}
	
	// internal method.
	TMSimulator.prototype.rebindButtons = function () {
	  var buttons = this.buttons;
	  var enable = (this.machine != null);
	  if (enable) {
	    rebindStepRun(buttons.step, buttons.run,
	      this.htmlForRunButton, this.htmlForPauseButton, this.machine);
	  }
	  buttons.all.forEach(function (b) { b.disabled = !enable; });
	};
	
	module.exports = TMSimulator;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Turing machine visualization component.
	 *
	 * • Adds running and reset on top of the base Turing machine.
	 * • Displays an animated state diagram and tape diagram.
	 * Does not include UI elements for controlling the machine.
	 *
	 * @module
	 */
	
	var TuringMachine = __webpack_require__(13).TuringMachine,
	    TapeViz = __webpack_require__(53),
	    StateGraph = __webpack_require__(50),
	    StateViz = __webpack_require__(51),
	    watchInit = __webpack_require__(17).watchInit,
	    d3 = __webpack_require__(2);
	
	/**
	 * Create an animated transition function.
	 * @param  {StateGraph} graph
	 * @param  {LayoutEdge -> any} animationCallback
	 * @return {(string, string) -> Instruction} Created transition function.
	 */
	function animatedTransition(graph, animationCallback) {
	  return function (state, symbol) {
	    var tuple = graph.getInstructionAndEdge(state, symbol);
	    if (tuple == null) { return null; }
	
	    animationCallback(tuple.edge);
	    return tuple.instruction;
	  };
	}
	
	/**
	 * Default edge animation callback.
	 * @param  {{domNode: Node}} edge
	 * @return {D3Transition} The animation. Use this for transition chaining.
	 */
	function pulseEdge(edge) {
	  var edgepath = d3.select(edge.domNode);
	  return edgepath
	      .classed('active-edge', true)
	    .transition()
	      .style('stroke-width', '3px')
	    .transition()
	      .style('stroke-width', '1px')
	    .transition()
	      .duration(0)
	      .each('start', /* @this edge */ function () {
	        d3.select(this).classed('active-edge', false);
	      })
	      .style('stroke', null)
	      .style('stroke-width', null);
	}
	
	function addTape(div, spec) {
	  return new TapeViz(div.append('svg').attr('class', 'tm-tape'), 9,
	    spec.blank, spec.input ? String(spec.input).split('') : []);
	}
	
	/**
	 * Construct a new state and tape visualization inside a &lt;div&gt;.
	 * @constructor
	 * @param {HTMLDivElement} div        div to take over and use.
	 * @param                  spec       machine specification
	 * @param {PositionTable} [posTable]  position table for the state nodes
	 */
	function TMViz(div, spec, posTable) {
	  div = d3.select(div);
	  var graph = new StateGraph(spec.table);
	  this.stateviz = new StateViz(
	    div,
	    graph.getVertexMap(),
	    graph.getEdges()
	  );
	  if (posTable != undefined) { this.positionTable = posTable; }
	
	  this.edgeAnimation = pulseEdge;
	  this.stepInterval = 100;
	
	  var self = this;
	  // We hook into the animation callback to know when to start the next step (when running).
	  function animateAndContinue(edge) {
	    var transition = self.edgeAnimation(edge);
	    if (self.isRunning) {
	      transition.transition().duration(self.stepInterval).each('end', function () {
	        // stop if machine was paused during the animation
	        if (self.isRunning) { self.step(); }
	      });
	    }
	  }
	
	  this.machine = new TuringMachine(
	    animatedTransition(graph, animateAndContinue),
	    spec.startState,
	    addTape(div, spec)
	  );
	  // intercept and animate when the state is set
	  watchInit(this.machine, 'state', function (prop, oldstate, newstate) {
	    d3.select(graph.getVertex(oldstate).domNode).classed('current-state', false);
	    d3.select(graph.getVertex(newstate).domNode).classed('current-state', true);
	    return newstate;
	  });
	
	  // Sidenote: each "Step" click evaluates the transition function once.
	  // Therefore, detecting halting always requires its own step (for consistency).
	  this.isHalted = false;
	
	  var isRunning = false;
	  /**
	   * Set isRunning to true to run the machine, and false to stop it.
	   */
	  Object.defineProperty(this, 'isRunning', {
	    configurable: true,
	    get: function () { return isRunning; },
	    set: function (value) {
	      if (isRunning !== value) {
	        isRunning = value;
	        if (isRunning) { this.step(); }
	      }
	    }
	  });
	
	  this.__parentDiv = div;
	  this.__spec = spec;
	}
	
	/**
	 * Step the machine immediately and interrupt any animations.
	 */
	TMViz.prototype.step = function () {
	  if (!this.machine.step()) {
	    this.isRunning = false;
	    this.isHalted = true;
	  }
	};
	
	/**
	 * Reset the Turing machine to its starting configuration.
	 */
	TMViz.prototype.reset = function () {
	  this.isRunning = false;
	  this.isHalted = false;
	  this.machine.state = this.__spec.startState;
	  this.machine.tape.domNode.remove();
	  this.machine.tape = addTape(this.__parentDiv, this.__spec);
	};
	
	Object.defineProperty(TMViz.prototype, 'positionTable', {
	  get: function ()  { return this.stateviz.positionTable; },
	  set: function (posTable) { this.stateviz.positionTable = posTable; }
	});
	
	module.exports = TMViz;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	/**
	 * Construct a Turing machine.
	 * @param {(state, symbol) -> ?{state: state, symbol: symbol, move: direction}}
	 *   transition
	 *   A transition function that, given *only* the current state and symbol,
	 *   returns an object with the following properties: symbol, move, and state.
	 *   Returning null/undefined halts the machine (no transition defined).
	 * @param {state} startState  The state to start in.
	 * @param         tape        The tape to use.
	 */
	function TuringMachine(transition, startState, tape) {
	  this.transition = transition;
	  this.state = startState;
	  this.tape = tape;
	}
	
	TuringMachine.prototype.toString = function () {
	  return String(this.state) + '\n' + String(this.tape);
	};
	
	/**
	 * Step to the next configuration according to the transition function.
	 * @return {boolean} true if successful (the transition is defined),
	 *   false otherwise (machine halted)
	 */
	TuringMachine.prototype.step = function () {
	  var instruct = this.nextInstruction;
	  if (instruct == null) { return false; }
	
	  this.tape.write(instruct.symbol);
	  move(this.tape, instruct.move);
	  this.state = instruct.state;
	
	  return true;
	};
	
	Object.defineProperties(TuringMachine.prototype, {
	  nextInstruction: {
	    get: function () { return this.transition(this.state, this.tape.read()); },
	    enumerable: true
	  },
	  isHalted: {
	    get: function () { return this.nextInstruction == null; },
	    enumerable: true
	  }
	});
	
	// Allows for both notational conventions of moving the head or moving the tape
	function move(tape, direction) {
	  switch (direction) {
	    case MoveHead.right: tape.headRight(); break;
	    case MoveHead.left:  tape.headLeft();  break;
	    default: throw new TypeError('not a valid tape movement: ' + String(direction));
	  }
	}
	var MoveHead = Object.freeze({
	  left:  {toString: function () { return 'G'; } },
	  right: {toString: function () { return 'D'; } }
	});
	var MoveTape = Object.freeze({left: MoveHead.right, right: MoveHead.left});
	
	exports.MoveHead = MoveHead;
	exports.MoveTape = MoveTape;
	exports.TuringMachine = TuringMachine;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var TM = __webpack_require__(13),
	    jsyaml = __webpack_require__(19),
	    _ = __webpack_require__(6);
	
	/**
	 * Thrown when parsing a string that is valid as YAML but invalid
	 * as a machine specification.
	 *
	 * Examples: unrecognized synonym, no start state defined,
	 * transitioning to an undeclared state.
	 *
	 * A readable message is generated based on the details (if any) provided.
	 * @param {string} reason  A readable error code.
	 *   As an error code, this should be relatively short and not include runtime values.
	 * @param {?Object} details Optional details. Possible keys:
	 *                          problemValue, state, key, synonym, info, suggestion
	 */
	function TMSpecError(reason, details) {
	  this.name = 'TMSpecError';
	  this.stack = (new Error()).stack;
	
	  this.reason = reason;
	  this.details = details || {};
	}
	TMSpecError.prototype = Object.create(Error.prototype);
	TMSpecError.prototype.constructor = TMSpecError;
	
	// generate a formatted description in HTML
	Object.defineProperty(TMSpecError.prototype, 'message', {
	  get: function () {
	    var header = this.reason;
	    var details = this.details;
	
	    function code(str) { return '<code>' + str + '</code>'; }
	    function showLoc(state, symbol, synonym) {
	      if (state != null) {
	        if (symbol != null) {
	          return ' in the transition from state ' + code(state) + ' and symbol ' + code(symbol);
	        } else {
	          return ' for state ' + code(state);
	        }
	      } else if (synonym != null) {
	        return ' in the definition of synonym ' + code(synonym);
	      }
	      return '';
	    }
	    var problemValue = details.problemValue ? ' ' + code(details.problemValue) : '';
	    var location = showLoc(details.state, details.symbol, details.synonym);
	    var sentences = ['<strong>' + header + problemValue + '</strong>' + location
	      , details.info, details.suggestion]
	      .filter(_.identity)
	      .map(function (s) { return s + '.'; });
	    if (location) { sentences.splice(1, 0, '<br>'); }
	    return sentences.join(' ');
	  },
	  enumerable: true
	});
	
	// type TransitionTable = {[key: string]: ?{[key: string]: string} }
	// type TMSpec = {blank: string, start state: string, table: TransitionTable}
	
	// IDEA: check with flow (flowtype.org)
	// throws YAMLException on YAML syntax error
	// throws TMSpecError for an invalid spec (eg. no start state, transitioning to an undefined state)
	// string -> TMSpec
	function parseSpec(str) {
	  var obj = jsyaml.safeLoad(str);
	  // check for required object properties.
	  // auto-convert .blank and 'start state' to string, for convenience.
	  if (obj == null) { throw new TMSpecError('The document is empty',
	    {info: 'Every Turing machine requires a <code>blank</code> tape symbol,' +
	    ' a <code>start state</code>, and a transition <code>table</code>'}); }
	  var detailsForBlank = {suggestion:
	    'Examples: <code>blank: \' \'</code>, <code>blank: \'0\'</code>'};
	  if (obj.blank == null) {
	    throw new TMSpecError('No blank symbol was specified', detailsForBlank);
	  }
	  obj.blank = String(obj.blank);
	  if (obj.blank.length !== 1) {
	    throw new TMSpecError('The blank symbol must be a string of length 1', detailsForBlank);
	  }
	  obj.startState = obj['start state'];
	  delete obj['start state'];
	  if (obj.startState == null) {
	    throw new TMSpecError('No start state was specified',
	    {suggestion: 'Assign one using <code>start state: </code>'});
	  }
	  obj.startState = String(obj.startState);
	  // parse synonyms and transition table
	  checkTableType(obj.table); // parseSynonyms assumes a table object
	  var synonyms = parseSynonyms(obj.synonyms, obj.table);
	  obj.table = parseTable(synonyms, obj.table);
	  // check for references to non-existent states
	  if (!(obj.startState in obj.table)) {
	    throw new TMSpecError('The start state has to be declared in the transition table');
	  }
	
	  return obj;
	}
	
	function checkTableType(val) {
	  if (val == null) {
	    throw new TMSpecError('Missing transition table',
	    {suggestion: 'Specify one using <code>table:</code>'});
	  }
	  if (typeof val !== 'object') {
	    throw new TMSpecError('Transition table has an invalid type',
	    {problemValue: typeof val,
	    info: 'The transition table should be a nested mapping from states to symbols to instructions'});
	  }
	}
	
	// (any, Object) -> ?SynonymMap
	function parseSynonyms(val, table) {
	  if (val == null) {
	    return null;
	  }
	  if (typeof val !== 'object') {
	    throw new TMSpecError('Synonyms table has an invalid type',
	      {problemValue: typeof val,
	      info: 'Synonyms should be a mapping from string abbreviations to instructions'
	        + ' (e.g. <code>accept: {R: accept}</code>)'});
	  }
	  return _.mapValues(val, function (actionVal, key) {
	    try {
	      return parseInstruction(null, table, actionVal);
	    } catch (e) {
	      if (e instanceof TMSpecError) {
	        e.details.synonym = key;
	        if (e.reason === 'Unrecognized string') {
	          e.details.info = 'Note that a synonym cannot be defined using another synonym';
	        }
	      }
	      throw e;
	    }
	  });
	}
	
	// (?SynonymMap, {[key: string]: string}) -> TransitionTable
	function parseTable(synonyms, val) {
	  return _.mapValues(val, function (stateObj, state) {
	    if (stateObj == null) {
	      // case: halting state
	      return null;
	    }
	    if (typeof stateObj !== 'object') {
	      throw new TMSpecError('State entry has an invalid type',
	      {problemValue: typeof stateObj, state: state,
	      info: 'Each state should map symbols to instructions. An empty map signifies a halting state.'});
	    }
	    return _.mapValues(stateObj, function (actionVal, symbol) {
	      try {
	        return parseInstruction(synonyms, val, actionVal);
	      } catch (e) {
	        if (e instanceof TMSpecError) {
	          e.details.state = state;
	          e.details.symbol = symbol;
	        }
	        throw e;
	      }
	    });
	  });
	}
	
	// omits null/undefined properties
	// (?string, direction, ?string) -> {symbol?: string, move: direction, state?: string}
	function makeInstruction(symbol, move, state) {
	  return Object.freeze(_.omitBy({symbol: symbol, move: move, state: state},
	    function (x) { return x == null; }));
	}
	
	function checkTarget(table, instruct) {
	  if (instruct.state != null && !(instruct.state in table)) {
	    throw new TMSpecError('Undeclared state', {problemValue: instruct.state,
	    suggestion: 'Make sure to list all states in the transition table and define their transitions (if any)'});
	  }
	  return instruct;
	}
	
	// throws if the target state is undeclared (not in the table)
	// type SynonymMap = {[key: string]: TMAction}
	// (SynonymMap?, Object, string | Object) -> TMAction
	function parseInstruction(synonyms, table, val) {
	  return checkTarget(table, function () {
	    switch (typeof val) {
	      case 'string': return parseInstructionString(synonyms, val);
	      case 'object': return parseInstructionObject(val);
	      default: throw new TMSpecError('Invalid instruction type',
	        {problemValue: typeof val,
	          info: 'An instruction can be a string (a direction <code>L</code>/<code>R</code> or a synonym)'
	            + ' or a mapping (examples: <code>{R: accept}</code>, <code>{write: \' \', L: start}</code>)'});
	    }
	  }());
	}
	
	var moveLeft = Object.freeze({move: TM.MoveHead.left});
	var moveRight = Object.freeze({move: TM.MoveHead.right});
	
	// case: direction or synonym
	function parseInstructionString(synonyms, val) {
	  if (val === 'L') {
	    return moveLeft;
	  } else if (val === 'R') {
	    return moveRight;
	  }
	  // note: this order prevents overriding L/R in synonyms, as that would
	  // allow inconsistent notation, e.g. 'R' and {R: ..} being different.
	  if (synonyms && synonyms[val]) { return synonyms[val]; }
	  throw new TMSpecError('Unrecognized string',
	    {problemValue: val,
	    info: 'An instruction can be a string if it\'s a synonym or a direction'});
	}
	
	// type ActionObj = {write?: any, L: ?string} | {write?: any, R: ?string}
	// case: ActionObj
	function parseInstructionObject(val) {
	  var symbol, move, state;
	  if (val == null) { throw new TMSpecError('Missing instruction'); }
	  // prevent typos: check for unrecognized keys
	  (function () {
	    var badKey;
	    if (!Object.keys(val).every(function (key) {
	      badKey = key;
	      return key === 'L' || key === 'R' || key === 'write';
	    })) {
	      throw new TMSpecError('Unrecognized key',
	      {problemValue: badKey,
	      info: 'An instruction always has a tape movement <code>L</code> or <code>R</code>, '
	        + 'and optionally can <code>write</code> a symbol'});
	    }
	  })();
	  // one L/R key is required, with optional state value
	  if ('L' in val && 'R' in val) {
	    throw new TMSpecError('Conflicting tape movements',
	    {info: 'Each instruction needs exactly one movement direction, but two were found'});
	  }
	  if ('L' in val) {
	    move = TM.MoveHead.left;
	    state = val.L;
	  } else if ('R' in val) {
	    move = TM.MoveHead.right;
	    state = val.R;
	  } else {
	    throw new TMSpecError('Missing movement direction');
	  }
	  // write key is optional, but must contain a char value if present
	  if ('write' in val) {
	    var writeStr = String(val.write);
	    if (writeStr.length === 1) {
	      symbol = writeStr;
	    } else {
	      throw new TMSpecError('Write requires a string of length 1');
	    }
	  }
	  return makeInstruction(symbol, move, state);
	}
	
	exports.TMSpecError = TMSpecError;
	exports.parseSpec = parseSpec;
	// re-exports
	exports.YAMLException = jsyaml.YAMLException;


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Lightweight property assignment watching by overriding getters/setters.
	 * Intended as a bridge between plain JS properties and other libraries.
	 *
	 * Inspired by https://gist.github.com/eligrey/384583, which works for
	 * data properties only, this works for both data and accessor properties.
	 *
	 * 2015-11-21
	 * @author Andy Li
	 */
	
	/**
	 * Watches a property for assignment by overriding it with a getter & setter
	 * on top of the previous value or accessors.
	 *
	 * The handler can intercept assignments by returning a different value.
	 * Watching an unwritable/unsettable property does nothing, but trying to watch
	 * a non-existent or non-configurable property fails fast with TypeError.
	 * @param  {!Object} thisArg The object that contains the property.
	 * @param  {String}  prop    The name of the property to watch.
	 * @param            handler The function to call when the property is
	 *   assigned to. Important: this function intercepts assignment;
	 *   its return value is set as the new value.
	 * @throws {TypeError} if object is null or does not have the property
	 * @throws {TypeError} if thisArg.prop is non-configurable
	 * @return {?Object}         The previous property descriptor, or null if the
	 *   property is not writable/settable.
	 */
	function watch(thisArg, prop, handler) {
	  var desc = Object.getOwnPropertyDescriptor(thisArg, prop);
	  // check pre-conditions: existent, configurable, writable/settable
	  if (desc === undefined) {
	    throw new TypeError('Cannot watch nonexistent property \''+prop+'\'');
	  } else if (!desc.configurable) {
	    throw new TypeError('Cannot watch non-configurable property \''+prop+'\'');
	  } else if (!desc.writable && desc.set === undefined) {
	    return; // no-op since property can't change without reconfiguration
	  }
	
	  var accessors = (function () {
	    if (desc.set) {
	      // case: .get/.set
	      return {
	        get: desc.get,
	        set: function (newval) {
	          return desc.set.call(thisArg, handler.call(thisArg, prop, thisArg[prop], newval));
	        }
	      };
	    } else {
	      // case: .value
	      var val = desc.value;
	      return {
	        get: function () {
	          return val;
	        },
	        set: function (newval) {
	          return val = handler.call(thisArg, prop, val, newval);
	        }
	      };
	    }
	  })();
	  Object.defineProperty(thisArg, prop, accessors);
	
	  return desc;
	}
	
	/**
	 * {@link watch} that, if successful, also calls the handler once with
	 *   the current value (by setting it).
	 * @see watch
	 */
	function watchInit(thisArg, prop, handler) {
	  var value = thisArg[prop];
	  var desc = watch(thisArg, prop, handler);
	  if (desc) { thisArg[prop] = value; }
	  return desc;
	}
	
	if (true) {
	  exports.watch = watch;
	  exports.watchInit = watchInit;
	}


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

	module.exports = jsyaml;

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "state-diagram/StateViz.css";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "tape/tape.css";

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = "input: '${2}'\nblank: '${3: }'\nstart state: ${4:start}\ntable:\n  ${4}:\n    ${5}\n"

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = "name: binary addition\nsource code: |\n  # Adds two binary numbers together.\n\n  # Format: Given input a+b where a and b are binary numbers,\n  # leaves c b on the tape, where c = a+b.\n  # Example: '11+1' => '100 1'.\n  input: '1011+11001'\n  blank: ' '\n  start state: right\n  table:\n    # Start at the second number's rightmost digit.\n    right:\n      [0,1,+]: R\n      ' ': {L: read}\n\n    # Add each digit from right to left:\n    # read the current digit of the second number,\n    read:\n      0: {write: c, L: have0}\n      1: {write: c, L: have1}\n      +: {write: ' ', L: rewrite}\n    # and add it to the next place of the first number,\n    # marking the place (using O or I) as already added.\n    have0: {[0,1]: L, +: {L: add0}}\n    have1: {[0,1]: L, +: {L: add1}}\n    add0:\n      [0,' ']: {write: O, R: back0}\n      1      : {write: I, R: back0}\n      [O,I]  : L\n    add1:\n      [0,' ']: {write: I, R: back1}\n      1      : {write: O, L: carry}\n      [O,I]  : L\n    carry:\n      [0,' ']: {write: 1, R: back1}\n      1      : {write: 0, L}\n    # Then, restore the current digit, and repeat with the next digit.\n    back0:\n      [0,1,O,I,+]: R\n      c: {write: 0, L: read}\n    back1:\n      [0,1,O,I,+]: R\n      c: {write: 1, L: read}\n\n    # Finish: rewrite place markers back to 0s and 1s.\n    rewrite:\n      O: {write: 0, L}\n      I: {write: 1, L}\n      [0,1]: L\n      ' ': {R: done}\n    done:\n\n\n  # Exercise:\n\n  # • Generate the Fibonacci sequence in binary, listed from right to left:\n  #   ...1101 1000 101 11 10 1 1 0\n  #   Hint: prefix the current number with a +, copy the previous number\n  #   and place it left of the +, run the adder, and repeat.\n  #   Example: '1 0' => '+1 0' => '0+1 0' => '1 1 0' => '+1 1 0' => ...\npositions:\n  right:   {x: 300, y: 130}\n  rewrite: {x: 500, y: 130}\n  done:    {x: 620, y: 130}\n\n  back0:  {x: 250, y: 250}\n  read:   {x: 400, y: 250}\n  back1:  {x: 550, y: 250}\n  carry:  {x: 650, y: 250}\n\n  add0:   {x: 150, y: 400}\n  have0:  {x: 300, y: 400}\n  have1:  {x: 500, y: 400}\n  add1:   {x: 650, y: 400}\n"

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = "name: binary increment\nsource code: |\n  # Adds 1 to a binary number.\n  input: '1011'\n  blank: ' '\n  start state: État 1\n  table:\n    # scan to the rightmost digit\n    État 1:\n      [1,0]: R\n      ' '  : {L: État 2}\n    # then carry the 1\n    État 2:\n      1      : {write: 0, L}\n      [0,' ']: {write: 1, L: Fin}\n    Fin:\n\n\n  # Exercises:\n\n  # • Modify the machine to always halt on the leftmost digit\n  #   (regardless of the number's length).\n  #   Hint: add a state between carry and done.\n\n  # • Make a machine that adds 2 instead of 1.\n  #   Hint: 2 is '10' in binary, so the last digit is unaffected.\n  #   Alternative hint: chain together two copies of the machine from\n  #   the first exercise (renaming the states of the second copy).\n\n  # • Make a machine to subtract 1.\n  #   To simplify things, assume the input is always greater than 0.\npositions:\n  État 1: {x: 200, y: 150}\n  État 2: {x: 400, y: 150}\n  Fin: {x: 600, y: 150}\n"

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = "name: binary multiplication\nsource code: |\n  # Multiplies two binary numbers together.\n\n  # Examples: '11*11' => '1001', '111*110' => '101010'.\n  input: '11*101' # 3*5 = 15 (1111 in binary)\n  blank: ' '\n  start state: start\n  table:\n    # Prefix the input with a '+', and go to the rightmost digit.\n    start:\n      [0,1]: {L: init}\n    init:\n      ' ': {write: '+', R: right}\n    right:\n      [0,1,'*']: R\n      ' ': {L: readB}\n\n    # Read and erase the last digit of the multiplier.\n    # If it's 1, add the current multiplicand.\n    # In any case, double the multiplicand afterwards.\n    readB:\n      0: {write: ' ', L: doubleL}\n      1: {write: ' ', L: addA}\n    addA:\n      [0,1]: L\n      '*': {L: read} # enter adder\n    # Double the multiplicand by appending a 0.\n    doubleL:\n      [0,1]: L\n      '*': {write: 0, R: shift}\n    double: # return from adder\n      [0,1,+]: R\n      '*': {write: 0, R: shift}\n    # Make room by shifting the multiplier right 1 cell.\n    shift:\n      0: {write: '*', R: shift0}\n      1: {write: '*', R: shift1}\n      ' ': {L: tidy} # base case: multiplier = 0\n    shift0:\n      0:   {R: shift0}\n      1:   {write: 0, R: shift1}\n      ' ': {write: 0, R: right}\n    shift1:\n      0:   {write: 1, R: shift0}\n      1:   {R: shift1}\n      ' ': {write: 1, R: right}\n\n    tidy:\n      [0,1]: {write: ' ', L}\n      +: {write: ' ', L: done}\n    done:\n\n  # This is the 'binary addition' machine almost verbatim.\n  # It's adjusted to keep the '+'\n  # and to lead to another state instead of halting.\n    read:\n      0: {write: c, L: have0}\n      1: {write: c, L: have1}\n      +: {L: rewrite} # keep the +\n    have0: {[0,1]: L, +: {L: add0}}\n    have1: {[0,1]: L, +: {L: add1}}\n    add0:\n      [0,' ']: {write: O, R: back0}\n      1      : {write: I, R: back0}\n      [O,I]  : L\n    add1:\n      [0,' ']: {write: I, R: back1}\n      1      : {write: O, L: carry}\n      [O,I]  : L\n    carry:\n      [0,' ']: {write: 1, R: back1}\n      1      : {write: 0, L}\n    back0:\n      [0,1,O,I,+]: R\n      c: {write: 0, L: read}\n    back1:\n      [0,1,O,I,+]: R\n      c: {write: 1, L: read}\n    rewrite:\n      O: {write: 0, L}\n      I: {write: 1, L}\n      [0,1]: L\n      ' ': {R: double} # when done, go to the 'double' state\n\n\n  # Remark:\n  # We can view the machine as expressing a recursive function:\n\n  #   multiply(a, b) = mult(0, a, b)\n\n  #   mult(acc, a, 0     ) = acc\n  #   mult(acc, a, 2k + 0) = mult(acc    , 2a, k)   where k ≠ 0\n  #   mult(acc, a, 2k + 1) = mult(acc + a, 2a, k)\n\n  # where a, b, and k are natural numbers.\n\n  # Each reduction maintains the invariant\n  #   mult(acc, a, b) = acc + a * b\n  # Note that mult's third argument (b) is always decreasing,\n  # so mult is guaranteed to halt.\n  # Eventually b reaches 0 and the result is simply the accumulator.\npositions:\n  start:  {x: 80 , y: 70}\n  init:   {x: 190, y: 70}\n  tidy:   {x: 730, y: 70}\n  done:   {x: 730, y: 180}\n\n  right:  {x: 300, y: 115}\n  shift:  {x: 600, y: 115}\n  shift1: {x: 450, y: 70}\n  shift0: {x: 450, y: 160}\n\n  readB:  {x: 300, y: 215}\n  addA:   {x: 160, y: 215}\n  doubleL: {x: 550, y: 215}\n\n  rewrite: {x: 363, y: 300}\n  double: {x: 650, y: 300}\n\n  back0:  {x: 160, y: 370}\n  read:   {x: 300, y: 370}\n  back1:  {x: 440, y: 370}\n  carry:  {x: 540, y: 370}\n\n  add0:   {x:  60, y: 470}\n  have0:  {x: 200, y: 470}\n  have1:  {x: 400, y: 470}\n  add1:   {x: 540, y: 470}\n"

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = "name: 3-state busy beaver\nsource code: |\n  # A 3-state 2-symbol busy beaver for most non-blank symbols.\n  # It takes 13 steps and leaves 6 non-blank symbols on the tape.\n\n  # What's a \"busy beaver\"?\n  #   Suppose every possible Turing machine with n states and k symbols\n  #   (for instance, 3 states and 2 symbols) were started on\n  #   a blank tape with no input.\n  #   Some of the machines would never halt. Out of the ones that do halt,\n  #   a machine that leaves the most non-blank symbols on the tape\n  #   is called a busy beaver.\n  blank: '0'\n  start state: A\n  table:\n    A:\n      0: {write: 1, R: B}\n      1: {L: C}\n    B:\n      0: {write: 1, L: A}\n      1: R\n    C:\n      0: {write: 1, L: B}\n      1: {R: H}\n    H:\n\n  # An alternative criterion is halting after the most steps.\n  # This busy beaver takes the most steps (21) but only prints 5 1's:\n    # A:\n    #   0: {write: 1, R: B}\n    #   1: {R: H}\n    # B:\n    #   0: {write: 1, L: B}\n    #   1: {write: 0, R: C}\n    # C:\n    #   0: {write: 1, L}\n    #   1: {L: A}\n    # H:\n\n\n  # Exercise:\n\n  # • Consider Turing machines that have n states and k symbols.\n  #   Instead of a missing instruction, halting is denoted by\n  #   a transition to a special \"halt\" state (for a total of n+1 states).\n  #   How many different transition functions are possible?\n\n  #   Hint: Each instruction writes a symbol, moves left or right,\n  #   and goes to a state.\n  #   There is one instruction per combination of non-halt state & symbol.\n\n\n\n  #   Answer: (2k(n+1))^(nk)\npositions:\n  A: {x: 320, y: 296.188}\n  B: {x: 400, y: 157.624}\n  C: {x: 480, y: 296.188}\n  H: {x: 400, y: 376.188}\n"

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = "name: 4-state busy beaver\nsource code: |\n  # A 4-state 2-symbol busy beaver\n  # that halts after 107 steps, leaving 13 1's on the tape.\n  # It takes the most steps *and* prints the most 1's.\n  blank: 0\n  start state: A\n  table:\n    A: {0: {write: 1, R: B}, 1:           {L: B}}\n    B: {0: {write: 1, L: A}, 1: {write: 0, L: C}}\n    C: {0: {write: 1, R: H}, 1:           {L: D}}\n    D: {0: {write: 1, R   }, 1: {write: 0, R: A}}\n    H:\n\n\n  # Finding a busy beaver requires considering every n-state k-symbol\n  # machine and proving either that it halts with no more non-blank symbols\n  # or that it never halts at all.\n\n  # Even with strategies to reduce the search space—\n  # including normalization, accelerated simulation, and automated proofs—\n  # there are still machines that show surprising complexity\n  # and require individual analysis.\n\n  # This 4-state busy beaver was proven by Allen Brady in 1983.\n  # Busy beavers for 5 states and above are as yet unknown.\n  # At the time of writing, the current 5-state 2-symbol contender\n  # takes 47,176,870 steps to halt, and the 6-state contender\n  # takes over 7.4 * 10^36534 steps\n  # (http://www.logique.jussieu.fr/~michel/bbc.html).\n  # \"Given that 5-state 2-symbol halting Turing machines can compute\n  # Collatz-like congruential functions, it may be very hard to find\n  # [the next busy beaver]\" (https://oeis.org/A060843).\n\n\n  # An entertaining read on busy beavers and their profoundness:\n\n  # • \"Who Can Name the Bigger Number?\"\n  #   http://www.scottaaronson.com/writings/bignumbers.html\npositions:\n  # square with side length 160\n  A: {x: 320, y: 170}\n  B: {x: 480, y: 170}\n\n  C: {x: 480, y: 330}\n  D: {x: 320, y: 330}\n  H: {x: 620, y: 330}\n"

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = "name: copy 1s\nsource code: |\n  # Copies a string of consecutive 1s.\n  input: '111'\n  blank: 0\n  start state: each\n  table:\n    # mark the current 1 by erasing it\n    each:\n      0: {R: H}\n      1: {write: 0, R: sep}\n    # skip to the separator\n    sep:\n      0: {R: add}\n      1: R\n    # skip to the end of the copy and write a 1\n    add:\n      0: {write: 1, L: sepL}\n      1: R\n    # return to the separator\n    sepL:\n      0: {L: next}\n      1: L\n    # return to the erased 1, restore it, and then advance to the next 1\n    next:\n      0: {write: 1, R: each}\n      1: L\n    H:\n\n\n  # Exercises:\n\n  # • Edit the machine to copy the string indefinitely,\n  #   i.e. given the input '11', produce 11011011011...\n  #   Hint: this can be done by modifying only one transition.\n\n  # • Make a machine to output the endless sequence 1011011101111011111...\npositions:\n  each: {x: 400   , y: 100}\n  sep:  {x: 400.01, y: 250}\n  add:  {x: 400.02, y: 400}\n  sepL: {x: 250   , y: 250}\n  next: {x: 250.01, y: 100}\n  H:    {x: 550   , y: 100}\n"

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = "name: divisible by 3\nsource code: |\n  # Checks if a binary number is divisible by 3.\n  input: '1001' # try '1111' (15), '10100' (20), '111001' (57)\n  blank: ' '\n  # How it works:\n\n  # Consider reading a binary number, say 10011 (19),\n  # from left to right one digit at a time.\n  # Each time a digit is read, the new value equals the new digit\n  # plus the old value shifted left one place (multiplied by 2).\n\n  # Digits  Value\n  # -------------\n  #         0\n  # 1       1\n  # 10      2\n  # 100     4\n  # 1001    9\n  # 10011   19\n\n  # Now instead of tracking the entire number, just track the remainder.\n  # It works the same way.\n  start state: q0\n  table:\n    q0:\n      0: R       # 2*0 + 0 = 0\n      1: {R: q1} # 2*0 + 1 = 1\n      ' ': {R: accept}\n    q1:\n      0: {R: q2} # 2*1 + 0 = 2\n      1: {R: q0} # 2*1 + 1 = 3\n    q2:\n      0: {R: q1} # 2*2 + 0 = 4\n      1: {R: q2} # 2*2 + 1 = 5\n    accept:\n\n\n  # Exercises:\n\n  # • Modify the machine to check if n-1 is divisible by 3,\n  #   where n is the input. That is, accept the binary of 1, 4, 7, 10, ...\n  #   Hint: this can be done without modifying the tape (no 'write').\n\n  # • Round the number up to the nearest multiple of 3.\n  #   Hint: do one pass right to find the remainder, then another pass left\n  #   to add. See the 'binary increment' example for how to add.\n\n  # • Round the number down to the nearest multiple of 3.\npositions:\n  q0: {x: 230, y: 250}\n  q1: {x: 400, y: 250}\n  q2: {x: 570, y: 250}\n  accept: {x: 230.01, y: 380}\n"

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = "name: divisible by 3 (base 10)\nsource code: |\n  # Checks if a base 10 number is divisible by 3.\n  input: 4728 # try 42, 57, 1337, 5328, 7521, 314159265\n  blank: ' '\n  # This uses the same idea as the base 2 version.\n  #\n  # To make things more interesting, we derive the step relation:\n  # Let x be the number left of the tape head,\n  #     d the digit under the head, and\n  #     x' the number up to and including the head.\n  # Then\n  #   x' = 10x + d .\n  # Notice 10 ≡ 1 (mod 3). Therefore\n  #   x' ≡ x + d (mod 3) .\n  # Each step simply adds the new digit's remainder mod 3.\n  start state: q0\n  table:\n    q0:\n      [0,3,6,9]: R     # 0 + 0 ≡ 0 (mod 3)\n      [1,4,7]: {R: q1} # 0 + 1 ≡ 1\n      [2,5,8]: {R: q2} # 0 + 2 ≡ 2\n      ' ': {R: accept}\n    q1:\n      [0,3,6,9]: R     # 1 + 0 ≡ 1\n      [1,4,7]: {R: q2} # 1 + 1 ≡ 2\n      [2,5,8]: {R: q0} # 1 + 2 ≡ 0\n    q2:\n      [0,3,6,9]: R     # 2 + 0 ≡ 2\n      [1,4,7]: {R: q0} # 2 + 1 ≡ 0\n      [2,5,8]: {R: q1} # 2 + 2 ≡ 1\n    accept:\n\n\n  # Exercises:\n\n  # • Check for divisibility by 5.\n  #   Hint: only 2 states (besides accept) are required.\n\n  # • Check for divisibility by 4.\n  #   Hint: use 4 states (besides accept).\npositions:\n  # centered equilateral triangle with side length 250\n  q0: {x: 275, y: 322.1688}\n  q1: {x: 400, y: 105.6624}\n  q2: {x: 525, y: 322.1688}\n  accept: {x: 275.01, y: 430}\n"

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = "name: multiplied lengths\nsource code: |\n  # Decides the language { a^(i)b^(j)c^(k) | i*j = k and i,j,k ≥ 1 }.\n  # (a's followed by b's then c's,\n  # where the number of a's multiplied by the number of b's\n  # equals the number of c's.)\n  input: aabbbcccccc # try abc, b, aabcbc, aabcc, aabbbbcccccccc\n  blank: ' '\n  start state: start\n\n  table:\n    # Check for the form a^(i)b^(j)c^(k) where i,j,k ≥ 1.\n    start:  {        a: {R: a+}}\n    a+:     {a: R,   b: {R: b+}}\n    b+:     {b: R,   c: {R: c+}}\n    c+:     {c: R, ' ': {L: left}}\n    left:\n      [a,b,c]: L\n      ' ': {R: eachA}\n    # Then check that i*j = k.\n    #   The approach is two nested loops:\n    #   For each 'a':\n    #     For each 'b':\n    #       Mark one 'c'\n    #   At the end, check that all c's are marked.\n    eachA:\n      a: {write: ' ', R: eachB}\n      b: {R: scan}\n    eachB:\n      a: R\n      b: {write: B, R: markC}\n      C: {L: nextA}\n    markC:\n      [b,C]: R\n      c: {write: C, L: nextB}\n    nextB:\n      [b,C]: L\n      B: {R: eachB}\n    nextA:\n      a: L\n      B: {write: b, L}\n      ' ': {R: eachA}\n\n    scan:\n      [b,C]: R\n      ' ': {R: accept}\n    accept:\npositions:\n  start:  {x: 180, y: 40}\n  a+:     {x: 180, y: 180}\n  b+:     {x: 180, y: 320}\n  c+:     {x: 180, y: 460}\n  left:   {x: 290, y: 320}\n\n  accept: {x: 400, y: 40}\n  eachA:  {x: 400, y: 180}\n  eachB:  {x: 400, y: 320}\n  markC:  {x: 400, y: 460}\n\n  scan:   {x: 560, y: 180}\n  nextA:  {x: 560, y: 320}\n  nextB:  {x: 560, y: 460}\n"

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = "name: equal strings\nsource code: |\n  # Decides the language { w#w | w ∈ {0,1}* }\n  # (two equal binary strings separated by '#')\n  input: '01001#01001' # try '#', '1#10', '10#1', '10#10'\n  blank: ' '\n  # Two strings are equal if they are both the empty string,\n  # or they start with the same symbol and are equal thereafter.\n  start state: start\n  table:\n    start:\n      # Inductive case: start with the same symbol.\n      0: {write: ' ', R: have0}\n      1: {write: ' ', R: have1}\n      # Base case: empty string.\n      '#': {R: check}\n    have0:\n      [0,1]: R\n      '#': {R: match0}\n    have1:\n      [0,1]: R\n      '#': {R: match1}\n    match0:\n      x: R\n      0: {write: x, L: back}\n    match1:\n      x: R\n      1: {write: x, L: back}\n    back:\n      [0,1,'#',x]: L\n      ' ': {R: start}\n    check:\n      x: R\n      ' ': {R: accept}\n    accept:\n\n\n  # Exercises:\n\n  # • Accept if the second string is the bitwise complement\n  #   (1s and 0s swapped) of the first, e.g. accept '1101#0010'.\n\n  # • Check that a binary string has the same number of 0s and 1s;\n  #   eg., accept '001110' but reject '10010'.\n\n  # • Check if two strings are different.\n  #   Example: accept '00#001' and '0101#0111', but reject '1001#1001'.\npositions:\n  accept: {x: 80 , y: 250}\n  check:  {x: 190, y: 250}\n  # regular hexagon with side length 150\n  start:  {x: 300, y: 250}\n  back:   {x: 600, y: 250}\n  have1:  {x: 375, y: 120.10}\n  match1: {x: 525, y: 120.10}\n  have0:  {x: 375, y: 379.90}\n  match0: {x: 525, y: 379.90}\n"

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = "name: three equal lengths\nsource code: |\n  # Decides the language { aⁿbⁿcⁿ | n ≥ 1 }, that is,\n  # accepts a's followed by b's then c's of the same length.\n  input: aabbcc # try bac, aabc, aabcc, aabcbc\n  blank: ' '\n  # Mark the first a, b, and c on each pass (by capitalizing them).\n  # All a's must precede all b's, which must precede all c's.\n  # When there are no more a's,\n  # all input symbols should have been marked.\n  start state: qA\n  table:\n    qA:\n      a: {write: A, R: qB}\n      B: {R: scan}\n    qB:\n      [a,B]: R\n      b: {write: B, R: qC}\n    qC:\n      [b,C]: R\n      c: {write: C, L: back}\n    back:\n      [a,B,b,C]: L\n      A: {R: qA}\n    scan:\n      [B,C]: R\n      ' ': {R: accept}\n    accept:\n\n\n  # Exercises:\n\n  # • Suppose a ledger starts from 0 and gains one dollar for each +\n  #   and loses one for each -. Reading left to right,\n  #   check that the account never goes into the negative.\n  #   Examples: accept '+-++' and '++-+--', reject '-++' and '++---+'.\n\n  # • Check parentheses for proper nesting,\n  #   e.g. accept '()(()()())' but reject '(()))(' and '(()('.\npositions:\n  qA: {x: 240, y: 250}\n  qB: {x: 400, y: 250}\n  qC: {x: 560, y: 250}\n  back:   {x: 400, y: 370}\n  scan:   {x: 320, y: 150}\n  accept: {x: 480, y: 150}\n"

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = "name: palindrome\nsource code: |\n  # Accepts palindromes made of the symbols 'a' and 'b'\n  input: 'abba' # try a, ab, bb, babab\n  blank: ' '\n  start state: start\n  synonyms:\n    accept: {R: accept}\n    reject: {R: reject}\n  # A palindrome is either the empty string, a single symbol,\n  # or a (shorter) palindrome with the same symbol added to both ends.\n  table:\n    start:\n      a: {write: ' ', R: haveA}\n      b: {write: ' ', R: haveB}\n      ' ': accept # empty string\n    haveA:\n      [a,b]: R\n      ' ': {L: matchA}\n    haveB:\n      [a,b]: R\n      ' ': {L: matchB}\n    matchA:\n      a: {write: ' ', L: back} # same symbol at both ends\n      b: reject\n      ' ': accept # single symbol\n    matchB:\n      a: reject\n      b: {write: ' ', L: back} # same symbol at both ends\n      ' ': accept # single symbol\n    back:\n      [a,b]: L\n      ' ': {R: start}\n    accept:\n    reject:\n\n\n  # Exercise:\n\n  # • Modify the machine to include 'c' in the symbol alphabet,\n  #   so it also works for strings like 'cabbac'.\npositions:\n  haveA:  {x: 240, y: 185}\n  start:  {x: 400, y: 185}\n  haveB:  {x: 560, y: 185}\n\n  matchA: {x: 240, y: 315}\n  back:   {x: 400, y: 315}\n  matchB: {x: 560, y: 315}\n\n  accept: {x: 400, y: 55}\n  reject: {x: 400, y: 445}\n"

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = "name: powers of two\nsource code: |\n  # Matches strings of 0s whose length is a power of two.\n\n  # This example comes from the textbook\n  #   \"Introduction to the Theory of Computation\" (3rd edition, 2012)\n  #   by Michael Sipser\n  # The states have been renamed (from q1, q2, etc.)\n  # to make it easier to understand.\n  input: '0000' # try '0', '000', '00000000'\n  blank: ' '\n  start state: zero\n  synonyms:\n    accept: {R: accept}\n    reject: {R: reject}\n  # The idea: divide the length by 2 repeatedly until it reaches 1.\n\n  # To do this, cross off every other 0, one pass at a time.\n  # If any pass reads an odd number of 0s (a remainder), reject right away.\n  # Otherwise if every pass halves the length cleanly,\n  # the length must be a power of two (1*2^n for n ≥ 0).\n\n  # Note that since the first 0 is never crossed off, we can simply\n  # erase it on the first pass and start the count from 1 from then on.\n  table:\n    zero:\n      0  : {write: ' ', R: one}\n      ' ': reject\n    # Base case: accept length of 1 = 2^0.\n    one:\n      0  : {write: x, R: even}\n      ' ': accept\n      x  : R\n    # Inductive case: divide by 2 and check for no remainder.\n    even:\n      0  : {R: odd}\n      ' ': {L: back} # return for another pass\n      x  : R\n    odd: # odd and > 1\n      0  : {write: x, R: even}\n      ' ': reject # odd number of 0s on this pass\n      x  : R\n    back:\n      ' ': {R: one}\n      [0,x]: L\n    accept:\n    reject:\npositions:\n  zero:   {x: 200, y: 200}\n  one:    {x: 400, y: 200}\n  even:   {x: 600, y: 200}\n\n  odd:    {x: 600, y: 385}\n  back:   {x: 500, y: 125}\n  accept: {x: 400, y: 300}\n  reject: {x: 200, y: 385}\n"

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = "name: repeat 0 1\nsource code: |\n  # This is the first example machine given by Alan Turing in his 1936 paper\n  #   \"On Computable Numbers, with an Application to\n  #    the Entscheidungsproblem\".\n  # It simply writes the endless sequence 0 1 0 1 0 1...\n  blank: ' '\n  start state: b\n  table:\n    b:\n      ' ': {write: 0, R: c}\n    c:\n      ' ':           {R: e}\n    e:\n      ' ': {write: 1, R: f}\n    f:\n      ' ':           {R: b}\n\n\n  # (Turing uses the convention of leaving a gap after each output cell,\n  # reserving it for marking the cell. For instance, on a tape that\n  # contains '0 1x0 0 1 1y1y0y', x marks the leftmost 1 and y marks 110.)\npositions:\n  b: {x: 300, y: 200, fixed: false}\n  c: {x: 450, y: 150, fixed: false}\n  e: {x: 500, y: 300, fixed: false}\n  f: {x: 350, y: 350, fixed: false}\n"

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = "name: unary multiplication\nsource code: |\n  # Multiplies together two unary numbers separated by a '*'.\n  # (Unary is like tallying. Here '||*|||' means 2 times 3.)\n  input: '||*|||' # try '*', '|*|||', '||||*||'\n  blank: ' '\n\n  # The idea:\n  #   multiply(0, b) = 0\n  #   multiply(a, b) = b + multiply(a-1, b)   when a > 0\n  start state: eachA\n  table:\n    # For each 1 in a, add a copy of b.\n    eachA:\n      '|': {write: ' ', R: toB}  # Inductive case: a > 0.\n      '*': {R: skip}             # Base case:      a = 0.\n    toB:\n      '|': R\n      '*': {R: eachB} # enter copier\n    nextA: # return from copier\n      ' ': {write: '|', R: eachA}\n      ['|','*']: L\n\n    skip:\n      '|': R\n      ' ': {R: done}\n    done:\n\n    # This is the 'copy 1s' machine, with ' ' as 0 and '|' as 1.\n    eachB:\n      ' ': {L: nextA}\n      '|': {write: ' ', R: sep}\n    sep:\n      ' ': {R: add}\n      '|': R\n    add:\n      ' ': {write: '|', L: sepL}\n      '|': R\n    sepL:\n      ' ': {L: nextB}\n      '|': L\n    nextB:\n      ' ': {write: '|', R: eachB}\n      '|': L\n\npositions:\n  eachA:  {x: 400, y:  50}\n  toB:    {x: 400, y: 150}\n  eachB:  {x: 400, y: 250}\n  sep:   {x: 400, y: 350}\n  add:   {x: 400, y: 450}\n\n  sepL:  {x: 280, y: 350}\n  nextB:  {x: 280, y: 250}\n\n  nextA:  {x: 280, y: 90}\n  skip:   {x: 520, y: 90}\n  done:   {x: 520, y: 190}\n"

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./_template.yaml": 26,
		"./binaryAdd.yaml": 27,
		"./binaryIncrement.yaml": 28,
		"./binaryMult.yaml": 29,
		"./busyBeaver3.yaml": 30,
		"./busyBeaver4.yaml": 31,
		"./copy1s.yaml": 32,
		"./divisibleBy3.yaml": 33,
		"./divisibleBy3Base10.yaml": 34,
		"./lengthMult.yaml": 35,
		"./matchBinaryStrings.yaml": 36,
		"./matchThreeLengths.yaml": 37,
		"./palindrome.yaml": 38,
		"./powersOfTwo.yaml": 39,
		"./repeat01.yaml": 40,
		"./unaryMult.yaml": 41
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 44;


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(6);
	
	
	/* Interface
	  type TransitionTable = {
	    [state: string]: ?{
	      [symbol: string]: Instruction
	    }
	  };
	  type Instruction = { state?: string, symbol?: string };
	
	  type DiagramGraph = {
	    [state: string]: {
	      label: string,
	      transitions: ?{
	        [symbol: string]: {
	          instruction: Instruction,
	          edge: LayoutEdge
	        }
	      }
	    }
	  };
	  type LayoutEdge = { source: Object, target: Object, labels: [string] }
	 */
	
	/**
	 * Use a transition table to derive the graph (vertices & edges) for a D3 diagram.
	 * Edges with the same source and target are combined.
	 * NB. In addition to single symbols, comma-separated symbols are supported.
	 * e.g. symbol string '0,1,,,I' -> symbols [0,1,',','I'].
	 */
	// TransitionTable -> DiagramGraph
	function deriveGraph(table) {
	  // We need two passes, since edges may point at vertices yet to be created.
	  // 1. Create all the vertices.
	  var graph = _.mapValues(table, function (transitions, state) {
	    return {
	      label: state,
	      transitions: transitions
	    };
	  });
	  // 2. Create the edges, which can now point at any vertex object.
	  var allEdges = [];
	  _.forEach(graph, function (vertex, state) {
	
	    vertex.transitions = vertex.transitions && (function () {
	      var stateTransitions = {};
	
	      // Combine edges with the same source and target
	      var cache = {};
	      function edgeTo(target, label) {
	        var edge = cache[target] ||
	          _.tap(cache[target] = {
	            source: vertex,
	            target: graph[target],
	            labels: []
	          }, allEdges.push.bind(allEdges));
	        edge.labels.push(label);
	        return edge;
	      }
	      // Create symbol -> instruction object map
	      _.forEach(vertex.transitions, function (instruct, symbolKey) {
	        // Handle comma-separated symbols.
	        // Recreate array by splitting on ','. Treat 2 consecutive ',' as , ','.
	        var symbols = symbolKey.split(',').reduce(function (acc, x) {
	          if (x === '' && acc[acc.length-1] === '') {
	            acc[acc.length-1] = ',';
	          } else {
	            acc.push(x);
	          }
	          return acc;
	        }, []);
	        var target = instruct.state != null ? instruct.state : state;
	        var edge = edgeTo(target, labelFor(symbols, instruct));
	
	        symbols.forEach(function (symbol) {
	          stateTransitions[symbol] = {
	            // Normalize for execution, but display the less-cluttered original.
	            instruction: normalize(state, symbol, instruct),
	            edge: edge
	          };
	        });
	      });
	
	      return stateTransitions;
	    }());
	
	  });
	
	  return {graph: graph, edges: allEdges};
	}
	
	// Normalize an instruction to include an explicit state and symbol.
	// e.g. {symbol: '1'} normalizes to {state: 'q0', symbol: '1'} when in state q0.
	function normalize(state, symbol, instruction) {
	  return _.defaults({}, instruction, {state: state, symbol: symbol});
	}
	
	function labelFor(symbols, action) {
	  var rightSide = ((action.symbol == null) ? '' : (visibleSpace(String(action.symbol)) + ','))
	    + String(action.move);
	  return symbols.map(visibleSpace).join(',') + '→' + rightSide;
	}
	
	// replace ' ' with '␣'.
	function visibleSpace(c) {
	  return (c === ' ') ? '␣' : c;
	}
	
	
	/**
	 * Aids rendering and animating a transition table in D3.
	 *
	 * • Generates the vertices and edges ("nodes" and "links") for a D3 diagram.
	 * • Provides mapping of each state to its vertex and each transition to its edge.
	 * @param {TransitionTable} table
	 */
	function StateGraph(table) {
	  var derived = deriveGraph(table);
	  Object.defineProperties(this, {
	    __graph: { value: derived.graph },
	    __edges: { value: derived.edges }
	  });
	}
	
	/**
	 * D3 layout "nodes".
	 */
	// StateGraph.prototype.getVertices = function () {
	//   return _.values(this.__graph);
	// };
	
	/**
	 * Returns the mapping from states to vertices (D3 layout "nodes").
	 * @return { {[state: string]: Object} }
	 */
	StateGraph.prototype.getVertexMap = function () {
	  return this.__graph;
	};
	
	/**
	 * D3 layout "links".
	 */
	StateGraph.prototype.getEdges = function () {
	  return this.__edges;
	};
	
	/**
	 * Look up a state's corresponding D3 "node".
	 */
	StateGraph.prototype.getVertex = function (state) {
	  return this.__graph[state];
	};
	
	StateGraph.prototype.getInstructionAndEdge = function (state, symbol) {
	  var vertex = this.__graph[state];
	  if (vertex === undefined) {
	    throw new Error('not a valid state: ' + String(state));
	  }
	
	  return vertex.transitions && vertex.transitions[symbol];
	};
	
	
	module.exports = StateGraph;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isBrowserIEorEdge = __webpack_require__(4).isBrowserIEorEdge;
	var d3 = __webpack_require__(2);
	var _ = __webpack_require__(1);
	var assign = __webpack_require__(6).assign; // need mutable assign()
	
	// *** Arrays as vectors ***
	
	// Add vectors.
	// Note: dimensions are not checked. Missing dimensions become NaN.
	function addV(array1, array2) {
	  return array1.map(function (x, i) { return x + array2[i]; });
	}
	
	function negateV(array) {
	  return array.map(function (x) { return -x; });
	}
	
	function subtractV(array1, array2) {
	  return addV(array1, negateV(array2));
	}
	
	// Scale the vector by a scalar.
	function multiplyV(array, scalar) {
	  return array.map(function (x) { return scalar*x; });
	}
	
	// Vector norm, squared
	function normSqV(array) {
	  function sq(x) { return x*x; }
	  function add(x, y) { return x + y; }
	  return array.map(sq).reduce(add, 0);
	}
	
	// Vector norm
	function normV(array) { return Math.sqrt(normSqV(array)); }
	
	// Return a copy of the vector rescaled as a unit vector (norm = 1).
	function unitV(array) {
	  var n = normV(array);
	  return array.map(function (x) { return x / n; });
	}
	
	// *** 2D Vectors ***
	function angleV(array) {
	  var x = array[0], y = array[1];
	  return Math.atan2(y, x);
	}
	
	function vectorFromLengthAngle(length, angle) {
	  return [Math.cos(angle) * length, Math.sin(angle) * length];
	}
	
	// *** Utilities ***
	
	// Count the directed edges that start at a given node and end at another.
	// Important: each node must have a unique .index property.
	// Example usage:
	// var counts = new EdgeCounter(edges);
	// var edgesFrom2To5 = counts.numEdgesFromTo(2,5);
	// var edgesFrom5to2 = counts.numEdgesFromTo(5,2);
	function EdgeCounter(edges) {
	  edges.forEach(function (e) {
	    var key = e.source.index +','+ e.target.index;
	    this[key] = (this[key] || 0) + 1;
	  }, this);
	}
	
	EdgeCounter.prototype.numEdgesFromTo = function (src, target) {
	  return this[String(src)+','+String(target)] || 0;
	};
	
	var EdgeShape = Object.freeze({
	  loop: {},     // self-loop: a->a
	  arc: {},      // curved arc: a->b when b->a exists
	  straight: {}  // straight edge: a->b when b->a does not exist
	});
	
	EdgeCounter.prototype.shapeForEdge = function (e) {
	  if (e.target.index === e.source.index) {
	    return EdgeShape.loop;
	  } else if (this.numEdgesFromTo(e.target.index, e.source.index)) {
	    // has returning edge => arc
	    return EdgeShape.arc;
	  } else {
	    return EdgeShape.straight;
	  }
	};
	
	// create a function that will compute an edge's SVG 'd' attribute.
	function edgePathFor(nodeRadius, shape, d) {
	  // case: self-loop
	  var loopEndOffset, loopArc;
	  if (shape === EdgeShape.loop) {
	    // start at the top (90°), end slightly above the right (15°)
	    loopEndOffset = vectorFromLengthAngle(nodeRadius, -15 * Math.PI/180);
	    loopArc = ' a 19,27 45 1,1 ' + loopEndOffset[0] + ',' + (loopEndOffset[1]+nodeRadius);
	    return function () {
	      var x1 = d.source.x,
	          y1 = d.source.y;
	      return 'M ' + x1 + ',' + (y1-nodeRadius) + loopArc;
	    };
	  }
	  // case: between nodes
	  if (shape === EdgeShape.arc) {
	    // sub-case: arc
	    return function () {
	      // note: p1 & p2 have to be delayed, to access x/y at the time of the call
	      var p1 = [d.source.x, d.source.y];
	      var p2 = [d.target.x, d.target.y];
	      var offset = subtractV(p2, p1);
	      var radius = 6/5*normV(offset);
	      // Note: SVG's y-axis is flipped, so vector angles are negative
	      // relative to standard coordinates (as used in Math.atan2).
	      // Proof: angle(r <cos ϴ, -sin ϴ>) = angle(r <cos -ϴ, sin -ϴ>) = -ϴ.
	      var angle = angleV(offset);
	      var sep = -Math.PI/2/2; // 90° separation, half on each side
	      var source = addV(p1, vectorFromLengthAngle(nodeRadius, angle+sep));
	      var target = addV(p2, vectorFromLengthAngle(nodeRadius, angle+Math.PI-sep));
	      // IDEA: consider http://www.w3.org/TR/SVG/paths.html#PathDataCubicBezierCommands
	      return (p1[0] <= p2[0])
	        ? 'M '+source[0]+' '+source[1]+' A '+radius+' '+radius+' 0 0,1 '+target[0]+' '+target[1]
	        : 'M '+target[0]+' '+target[1]+' A '+radius+' '+radius+' 0 0,0 '+source[0]+' '+source[1];
	    };
	  } else if (shape === EdgeShape.straight) {
	    return function () {
	      // sub-case: straight line
	      var p1 = [d.source.x, d.source.y];
	      var p2 = [d.target.x, d.target.y];
	      var offset = subtractV(p2, p1);
	      // avoid spurious errors when bounding causes node centers to coincide
	      if (offset[0] === 0 && offset[1] === 0) { return null; }
	
	      var source = addV(p1, multiplyV(unitV(offset), nodeRadius));
	      var target = subtractV(p2, multiplyV(unitV(offset), nodeRadius));
	      return 'M '+source[0]+' '+source[1]+' L '+ target[0] +' '+ target[1];
	    };
	  }
	}
	
	function rectCenter(svgrect) {
	  return {x: svgrect.x + svgrect.width/2,
	          y: svgrect.y + svgrect.height/2};
	}
	
	function identity(x) { return x; }
	function noop() {}
	
	function limitRange(min, max, value) {
	  return Math.max(min, Math.min(value, max));
	}
	
	// IE padding hack so that SVG resizes properly.
	// This works across browsers but we only need it for IE.
	var appendSVGTo = !isBrowserIEorEdge
	  ? function (div) { return div.append('svg'); }
	  : function (div, hwRatio) {
	    return div
	      .append('div')
	        .style({
	          width: '100%',
	          height: '0',
	          'padding-bottom': (100 * hwRatio) + '%',
	          position: 'relative'
	        })
	      .append('svg')
	        .style({
	          position: 'absolute',
	          top: '0',
	          left: '0'
	        });
	  };
	
	// *** D3 diagram ***
	__webpack_require__(24);
	
	// type LayoutNode = {label: string};
	// type StateMap = {[state: string]: LayoutNode};
	
	/**
	 * Create a state diagram inside an SVG.
	 * Each vertex/edge (node/link) object is also annotated with @.domNode@
	 * corresponding to its SVG element.
	 *
	 * Note: currently, element IDs (e.g. for textPath) will collide if multiple
	 * diagrams are on the same document (HTML page).
	 * @param  {D3Selection}      container     Container to add the SVG to.
	 * @param  {[LayoutNode] | StateMap} nodes  Parameter to D3's force.nodes.
	 *   Important: passing a StateMap is recommended when using setPositionTable.
	 *   Passing an array will key the state nodes by array index.
	 * @param  {[LayoutEdge]}     linkArray     Parameter to D3's force.links.
	 */
	function StateViz(container, nodes, linkArray) {
	  /* References:
	    [Sticky Force Layout](http://bl.ocks.org/mbostock/3750558) demonstrates
	    drag to position and double-click to release.
	
	    [Graph with labeled edges](http://bl.ocks.org/jhb/5955887) demonstrates
	    arrow edges with auto-rotated labels.
	  */
	
	  /* eslint-disable no-invalid-this */ // eslint is not familiar with D3
	  var w = 800;
	  var h = 300;
	  var linkDistance = 140;
	  var nodeRadius = 40;
	
	  var colors = d3.scale.category10();
	
	  var svg = appendSVGTo(container, h/w);
	  svg.attr({
	    'viewBox': [0, 0, w, h].join(' '),
	    'version': '1.1',
	    ':xmlns': 'http://www.w3.org/2000/svg',
	    ':xmlns:xlink': 'http://www.w3.org/1999/xlink'
	  });
	
	  // Force Layout
	
	  // drag event handlers
	  function dragstart(d) {
	    d.fixed = true;
	    svg.transition()
	      .style('box-shadow', 'inset 0 0 1px gold');
	  }
	  function dragend() {
	    svg.transition()
	      .style('box-shadow', null);
	  }
	  function releasenode(d) {
	    d.fixed = false;
	    force.resume();
	  }
	
	  // set up force layout
	  var nodeArray = nodes instanceof Array ? nodes : _.values(nodes);
	  this.__stateMap = nodes;
	
	  var force = d3.layout.force()
	      .nodes(nodeArray)
	      .links(linkArray)
	      .size([w,h])
	      .linkDistance([linkDistance])
	      .charge([-500])
	      .theta(0.1)
	      .gravity(0.05)
	      .start();
	
	  var drag = force.drag()
	      .on('dragstart', dragstart)
	      .on('dragend', dragend);
	
	  // Edges
	  var edgeCounter = new EdgeCounter(linkArray);
	
	  var edgeselection = svg.selectAll('.edgepath')
	    .data(linkArray)
	    .enter();
	
	  var edgegroups = edgeselection.append('g');
	
	  var labelAbove = function (d, i) { return String(-1.1*(i+1)) + 'em'; };
	  var labelBelow = function (d, i) { return String(0.6+ 1.1*(i+1)) + 'em'; };
	
	  edgegroups.each(function (edgeD, edgeIndex) {
	    var group = d3.select(this);
	    var edgepath = group
	      .append('path')
	        .attr({'class': 'edgepath',
	               'id': 'edgepath'+edgeIndex })
	        .each(function (d) { d.domNode = this; });
	
	    var labels = group.selectAll('.edgelabel')
	      .data(edgeD.labels).enter()
	      .append('text')
	        .attr('class', 'edgelabel');
	    labels.append('textPath')
	        .attr('xlink:href', function () { return '#edgepath'+edgeIndex; })
	        .attr('startOffset', '50%')
	        .text(identity);
	    /* To reduce JS computation, label positioning varies by edge shape:
	        * Straight edges can use a fixed 'dy' value.
	        * Loops cannot use 'dy' since it increases letter spacing
	          as labels get farther from the path. Instead, since a loop's shape
	          is fixed, it allows a fixed translate 'transform'.
	        * Arcs are bent and their shape is not fixed, so neither 'dy'
	          nor 'transform' can be constant.
	          Fortunately the curvature is slight enough that a fixed 'dy'
	          looks good enough without resorting to dynamic translations.
	    */
	    var shape = edgeCounter.shapeForEdge(edgeD);
	    edgeD.getPath = edgePathFor(nodeRadius, shape, edgeD);
	    switch (shape) {
	      case EdgeShape.straight:
	        labels.attr('dy', labelAbove);
	        edgeD.refreshLabels = function () {
	          // flip edge labels that are upside-down
	          labels.attr('transform', function () {
	            if (edgeD.target.x < edgeD.source.x) {
	              var c = rectCenter(this.getBBox());
	              return 'rotate(180 '+c.x+' '+c.y+')';
	            } else {
	              return null;
	            }
	          });
	        };
	        break;
	      case EdgeShape.arc:
	        var isFlipped;
	        edgeD.refreshLabels = function () {
	          var shouldFlip = edgeD.target.x < edgeD.source.x;
	          if (shouldFlip !== isFlipped) {
	            edgepath.classed('reversed-arc', shouldFlip);
	            labels.attr('dy', shouldFlip ? labelBelow : labelAbove);
	            isFlipped = shouldFlip;
	          }
	        };
	        break;
	      case EdgeShape.loop:
	        labels.attr('transform', function (d, i) {
	          return 'translate(' + String(8*(i+1)) + ' ' + String(-8*(i+1)) + ')';
	        });
	        edgeD.refreshLabels = noop;
	        break;
	    }
	  });
	  var edgepaths = edgegroups.selectAll('.edgepath');
	
	  // Nodes
	  // note: nodes are added after edges so as to paint over excess edge lines
	  var nodeSelection = svg.selectAll('.node')
	    .data(nodeArray)
	    .enter();
	
	  var nodecircles = nodeSelection
	    .append('circle')
	      .attr('class', 'node')
	      .attr('r', nodeRadius)
	      .style('fill', function (d,i) { return colors(i); })
	      .each(function (d) { d.domNode = this; })
	      .on('dblclick', releasenode)
	      .call(drag);
	
	  var nodelabels = nodeSelection
	   .append('text')
	     .attr('class', 'nodelabel')
	     .attr('dy', '0.25em') /* dy doesn't work in CSS */
	     .text(function (d) { return d.label; });
	
	  // Arrowheads
	  var svgdefs = svg.append('defs');
	  svgdefs.selectAll('marker')
	      .data(['arrowhead', 'active-arrowhead', 'reversed-arrowhead', 'reversed-active-arrowhead'])
	    .enter().append('marker')
	      .attr({'id': function (d) { return d; },
	             'viewBox':'0 -5 10 10',
	             'refX': function (d) {
	               return (d.lastIndexOf('reversed-', 0) === 0) ? 0 : 10;
	             },
	             'orient':'auto',
	             'markerWidth':10,
	             'markerHeight':10
	            })
	    .append('path')
	      .attr('d', 'M 0 -5 L 10 0 L 0 5 Z')
	      .attr('transform', function (d) {
	        return (d.lastIndexOf('reversed-', 0) === 0) ? 'rotate(180 5 0)' : null;
	      });
	
	  var svgCSS =
	    '.edgepath {' +
	    '  marker-end: url(#arrowhead);' +
	    '}' +
	    '.edgepath.active-edge {' +
	    '  marker-end: url(#active-arrowhead);' +
	    '}' +
	    '.edgepath.reversed-arc {' +
	    '  marker-start: url(#reversed-arrowhead);' +
	    '  marker-end: none;' +
	    '}' +
	    '.edgepath.active-edge.reversed-arc {' +
	    '  marker-start: url(#reversed-active-arrowhead);' +
	    '  marker-end: none;' +
	    '}';
	  svg.append('style').each(function () {
	    if (this.styleSheet) {
	      this.styleSheet.cssText = svgCSS;
	    } else {
	      this.textContent = svgCSS;
	    }
	  });
	
	  // Force Layout Update
	  force.on('tick', function () {
	    // Keep coordinates in bounds. http://bl.ocks.org/mbostock/1129492
	    // NB. Bounding can cause node centers to coincide, especially at corners.
	    nodecircles.attr({cx: function (d) { return d.x = limitRange(nodeRadius, w - nodeRadius, d.x); },
	                      cy: function (d) { return d.y = limitRange(nodeRadius, h - nodeRadius, d.y); }
	    });
	
	    nodelabels.attr('x', function (d) { return d.x; })
	              .attr('y', function (d) { return d.y; });
	
	    edgepaths.attr('d', function (d) { return d.getPath(); });
	
	    edgegroups.each(function (d) { d.refreshLabels(); });
	
	    // Conserve CPU when layout is fully fixed
	    if (nodeArray.every(function (d) { return d.fixed; })) {
	      force.stop();
	    }
	  });
	  this.force = force;
	  /* eslint-enable no-invalid-this */
	}
	
	// Positioning
	
	// {[key: State]: Node} -> PositionTable
	var getPositionTable = _.mapValues(_.pick(['x', 'y', 'px', 'py', 'fixed']));
	
	// Tag nodes w/ positions. Mutates the node map.
	// PositionTable -> {[key: State]: Node} -> void
	function setPositionTable(posTable, stateMap) {
	  _.forEach(function (node, state) {
	    var position = posTable[state];
	    if (position !== undefined) {
	      assign(node, position);
	    }
	  }, stateMap);
	}
	
	Object.defineProperty(StateViz.prototype, 'positionTable', {
	  get: function () { return getPositionTable(this.__stateMap); },
	  set: function (posTable) {
	    setPositionTable(posTable, this.__stateMap);
	    // ensure that a cooled layout will update
	    this.force.resume();
	  }
	});
	
	
	module.exports = StateViz;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var _ = __webpack_require__(1);
	
	// Bidirectional infinite tape
	function Tape(blank, input) {
	  Object.defineProperty(this, 'blank', {
	    value: blank,
	    writable: false,
	    enumerable: true
	  });
	  // zipper data structure
	  // INVARIANTS: tape.before can be empty, tape.after must be nonempty.
	  // before: cells before the head (in order; left to right).
	  // after:  cells after and including the head (in reverse; right to left).
	  this.tape = {
	    before: [],
	    after: (input == null || input.length == 0) ? [blank] : input.slice().reverse(),
	    toString: function () {
	      return this.before.join('') + '🔎' + this.after.slice().reverse().join('');
	    }
	  };
	}
	
	// Read the value at the tape head.
	Tape.prototype.read = function () {
	  return _.last(this.tape.after);
	};
	Tape.prototype.write = function (symbol) {
	  this.tape.after[this.tape.after.length - 1] = symbol;
	};
	
	Tape.prototype.headRight = function () {
	  var before = this.tape.before,
	      after = this.tape.after;
	  before.push(after.pop());
	  if (_.isEmpty(after)) {
	    after.push(this.blank);
	  }
	};
	Tape.prototype.headLeft = function () {
	  var before = this.tape.before,
	      after = this.tape.after;
	  if (_.isEmpty(before)) {
	    before.push(this.blank);
	  }
	  after.push(before.pop());
	};
	
	Tape.prototype.toString = function () {
	  return this.tape.toString();
	};
	
	// for tape visualization. not part of TM definition.
	// Read the value at an offset from the tape head.
	// 0 is the tape head. + is to the right, - to the left.
	Tape.prototype.readOffset = function (i) {
	  var tape = this.tape;
	  if (i >= 0) {
	    // right side: offset [0..length-1] ↦ array index [length-1..0]
	    return (i <= tape.after.length - 1) ? tape.after[tape.after.length - 1 - i] : this.blank;
	  } else {
	    // left side: offset [-1..-length] ↦ array index [length-1..0]
	    return (i >= -tape.before.length) ? tape.before[tape.before.length + i] : this.blank;
	  }
	};
	
	// for tape visualization.
	// Read the values from an offset range (inclusive of start and end).
	Tape.prototype.readRange = function (start, end) {
	  return _.range(start, end+1).map(function (i) {
	    return this.readOffset(i);
	  }, this);
	};
	
	module.exports = Tape;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Tape = __webpack_require__(52),
	    d3   = __webpack_require__(2);
	__webpack_require__(25);
	
	var cellWidth = 50;
	var cellHeight = 50;
	
	function initTapeCells(selection) {
	  selection.attr('class', 'tape-cell');
	  selection.append('rect')
	      // the box outline is purely visual, so remove its data binding
	      .datum(null)
	      .attr({'width': cellWidth,
	             'height': cellHeight});
	  selection.append('text')
	      .text(function (d) { return d; })
	      .attr({'x': cellWidth/2, 'y': cellHeight/2 + 8});
	  return selection;
	}
	
	function positionCells(selection, offset) {
	  offset = (offset == null) ? 0 : offset;
	  selection.attr('transform', function (d, i) {
	    return 'translate(' + (-cellWidth+10 + cellWidth*(i+offset)) + ')';
	  });
	  return selection;
	}
	
	function repositionWrapper(wrapper) {
	  wrapper.attr('transform', 'translate(0 10)')
	    .transition()
	      .duration(0)
	    .select('.exiting')
	      .remove();
	}
	
	// Tape visualization centered around the tape head.
	function TapeViz(svg, lookaround, blank, input) {
	  Tape.call(this, blank, input);
	
	  Object.defineProperty(this, 'lookaround', {
	    value: lookaround,
	    writable: false,
	    enumerable: true
	  });
	  Object.defineProperty(this, 'domNode', {
	    value: svg,
	    writable: false,
	    enumerable: true
	  });
	
	  // width is before + head + after, trimming 2 off to show cut-off tape ends
	  var width  = cellWidth * (lookaround+1+lookaround-2) + 2*10;
	  var height = cellHeight + 2*10;
	  svg.attr({
	    'width': '95%',
	    'viewBox': [0, 0, width, height].join(' ')
	  });
	
	  this.wrapper = svg.append('g')
	      .attr('class', 'wrapper')
	      .call(repositionWrapper);
	
	  svg.append('rect')
	      .attr({'id': 'tape-head',
	             'width': (1+1/5) * cellWidth,
	             'height': (1+1/5) * cellHeight,
	             'x': -cellWidth+10/2 + cellWidth*lookaround,
	             'y': 10/2
	           });
	
	  this.wrapper.selectAll('.tape-cell')
	      .data(this.readRange(-lookaround, lookaround))
	    .enter()
	    .append('g')
	      .call(initTapeCells)
	      .call(positionCells)
	  ;
	}
	
	TapeViz.prototype = Object.create(Tape.prototype);
	TapeViz.prototype.constructor = TapeViz;
	
	// IDEA: chain headLeft/Right to wait for write()?
	TapeViz.prototype.write = function (symbol) {
	  // don't animate if symbol stays the same
	  if (Tape.prototype.read.call(this) === symbol) {
	    return;
	  }
	  Tape.prototype.write.call(this, symbol);
	
	  // remove leftover .exiting in case animation was interrupted
	  this.wrapper.selectAll('.exiting').remove();
	
	  d3.select(this.wrapper[0][0].childNodes[this.lookaround])
	      .datum(symbol)
	    .select('text')
	      .attr('fill-opacity', '1')
	      .attr('stroke-opacity', '1')
	    .transition()
	      .attr('fill-opacity', '0.4')
	      .attr('stroke-opacity', '0.1')
	    .transition()
	      .text(function (d) { return d; })
	      .attr('fill-opacity', '1')
	      .attr('stroke-opacity', '1')
	    .transition()
	      .duration(0)
	      .attr('fill-opacity', null)
	      .attr('stroke-opacity', null)
	    ;
	};
	
	function moveHead(wrapper, enter, exit, wOffset, cOffset) {
	  // add to one end
	  enter.call(initTapeCells);
	  // remove from the other end
	  exit.classed('exiting', true);
	  // translate cells forward, and the wrapper backwards
	  wrapper.selectAll('.tape-cell')
	      .call(positionCells, cOffset);
	  wrapper
	      .attr('transform', 'translate(' + (wOffset*cellWidth).toString() + ' 10)')
	    // animate wrapper returning to neutral position
	    .transition()
	      .call(repositionWrapper);
	}
	
	TapeViz.prototype.headRight = function () {
	  Tape.prototype.headRight.call(this);
	  // remove leftover .exiting in case animation was interrupted.
	  // Important: call-by-value evaluates the selection argument(s) of 'moveHead' before
	  // before entering the function, so exiting nodes have to be removed beforehand.
	  this.wrapper.selectAll('.exiting').remove();
	  moveHead(this.wrapper,
	    // add to right end
	    this.wrapper.append('g')
	        .datum(this.readOffset(this.lookaround)),
	    // remove from left end
	    this.wrapper.select('.tape-cell'),
	    1, -1);
	};
	
	TapeViz.prototype.headLeft = function () {
	  Tape.prototype.headLeft.call(this);
	  this.wrapper.selectAll('.exiting').remove();
	  moveHead(this.wrapper,
	    this.wrapper.insert('g', ':first-child')
	        .datum(this.readOffset(-this.lookaround)),
	    this.wrapper.select('.wrapper > .tape-cell:last-of-type'),
	    -1, 0);
	};
	
	module.exports = TapeViz;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// TMViz.bundle.js